var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { initialState } from './reducer';
/**
 * Direct selector to the stylesPage state domain
 */
var selectStyleDomain = function (state) { return state.style || initialState; };
/**
 * Other specific selectors
 */
/**
 * Default selector used by StylesPage
 */
export var makeSelectStyle = function (state) {
    var styles = selectStyleDomain(state);
    return __assign(__assign({}, styles), { fullPalate: [styles.data.primaryColor, styles.data.secondaryColor] });
};
export default makeSelectStyle;
export { selectStyleDomain };
